export default "__VITE_ASSET__BBJy_e4C__"